import { useEffect, useMemo, useState } from "react";
import { fetchRemoteConfigData } from "../../../firebase";
import ModalTemplate from "../../../common/modal/modalTemplate";

const HowFeesWork = ({ show, closeModal }) => {
    const [list, setList] = useState([]);

    useEffect(() => {
        fetchRemoteConfigData('CUSTOMER_WEB_HOW_FEES_WORK')
            .then(data => setList(data || []))
            .catch(() => setList([]));
    }, []);

    const content = useMemo(
        () => (
            <div className="card border-0 shadow-none mb-0">
                <div className="card-body px-3 px-md-4 py-3">
                    <button
                        type="button"
                        className="custom-close-btn"
                        onClick={closeModal}
                        aria-label="Close"
                    >
                        ✕
                    </button>
                    <h3 className="material-charge-title mt-4">
                        Price breakdown
                    </h3>

                    {list.map(({ type, title, description }, index) => (
                        <div
                            key={index}
                            className="mb-4"
                        >
                            <h5 className="text-dark text-lg mb-1">
                                {title}
                            </h5>

                            <p className={`text-md mb-0 ${type === "warning" ? "text-danger text-md" : undefined}`}>
                                {description}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        ),
        [closeModal, list]
    );

    return (
        <ModalTemplate
            show={show}
            closeFun={closeModal}
            centered
            isRemoveBodyPadding={true}
            // title="How fees work"
            body={content}
            footer={null}
        />
    );
};

export default HowFeesWork;